import React from 'react'
import './style.scss'

export const Checkbox = ({...props}) => {
    return(
        <div className={`ldsrf-checkbox ${props && props.checked === true ? 'checked':''}`}>
            <input {...props} type="checkbox" name="listId" className="select-toggle" id="select"/>
            {props && props.checked ? <i class="fad fa-check toggle-icon"></i>:null}
        </div>
    )
}